import script from "./PriceEfficiency.vue?vue&type=script&lang=js"
export * from "./PriceEfficiency.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__